import { SuccessPlaceholder } from "@components"
import { Button } from "@heroui/react"
import { Link as RouterLink } from "react-router-dom"
import PropTypes from "prop-types"

const ScheduledActionSuccessMessage = ({ 
  advisories = [],
  advisoryLinkText,
  advisoryMessage,
  advisoryTitle,
  advisoryUrl,
  executeAt, 
  handleClose,
  title
}) => (
  <SuccessPlaceholder>
    <h1 className="text-lg text-foreground-700">{title}</h1>
    <h1 className="text-2xl font-semibold">{executeAt}</h1>
    
    {advisories.length > 0 && (
      <div className="flex flex-col mt-6">
        <p className="mb-1">Recommended next steps</p>
        
        <div className="flex flex-col gap-4">
          <h2 className="text-lg font-semibold text-danger-500">{advisoryTitle}</h2>
          
          <p>{advisoryMessage}</p>
        </div>
      </div>
    )}
    
    <p className="mt-4 text-sm text-foreground-400">
      We'll email you a daily event health report whenever action is required, including reminders before scheduled actions are due.
    </p>

    <div className="flex flex-wrap gap-3 mt-8">
      {advisories.length > 0 && advisoryUrl && <Button as={RouterLink} to={advisoryUrl} size="lg" color="secondary" fullWidth>{advisoryLinkText}</Button>}
      
      <Button size="lg" color="default" onPress={handleClose} fullWidth>
        Close
      </Button>
    </div>
  </SuccessPlaceholder>
)

ScheduledActionSuccessMessage.propTypes = {
  advisories: PropTypes.array,
  advisoryLinkText: PropTypes.string,
  advisoryMessage: PropTypes.string,
  advisoryTitle: PropTypes.string,
  advisoryUrl: PropTypes.string,
  executeAt: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
}

export default ScheduledActionSuccessMessage